'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import SrcCategoriesController from "./controller/srcCategories";
import SrcCategoryModalCreateController from "./controller/srcCategoryModalCreate";
import SrcCategoryTableDirective from "./directive/srcCategoryTable";
import SrcCategoryTreeDirective from "./directive/srcCategoryTree";
import SrcCategoryNodeDirective from "./directive/srcCategoryNode";
import SrcCategoryService from "./service/srcCategory";

export default angular.module('investmentProject.srcCategory', [])
// контроллеры
    .controller('SrcCategoriesController', SrcCategoriesController)
    .controller('SrcCategoryModalCreateController', SrcCategoryModalCreateController)
    // директивы
    .directive('srcCategoryTable', SrcCategoryTableDirective)
    .directive('srcCategoryTree', SrcCategoryTreeDirective)
    .directive('srcCategoryNode', SrcCategoryNodeDirective)
    .factory('SrcCategoryService', SrcCategoryService)
    .name;